import { render, staticRenderFns } from "./fornitoriProdotto.vue?vue&type=template&id=303715b4"
import script from "./fornitoriProdotto.vue?vue&type=script&lang=js"
export * from "./fornitoriProdotto.vue?vue&type=script&lang=js"
import style0 from "./fornitoriProdotto.vue?vue&type=style&index=0&id=303715b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports